<template>
    <div>
        <div class="table-container">
            <!-- хлебные крошки-->
            <div class="filter-breadcrumb">
                <span class="item-breadcrumb" v-if="dateTo !== null" >{{ 'Дата' }} - {{ dateTo}}</span>
                <span class="item-breadcrumb" v-if="reg !== null && reg_name !== null" >{{ reg }} - {{ reg_name }}</span>
                <span class="item-breadcrumb" v-if="reg_switch === false && codeCount.abp === 1">{{ 'АБП' }} - {{ countNumber('abp')}}</span>
                <span class="item-breadcrumb" v-if="reg_switch === false && codeCount.prg === 1">{{ 'Программа' }} - {{ countNumber('prg')}}</span>
                <span class="item-breadcrumb" v-if="reg_switch === false && codeCount.ppr === 1">{{ 'Подпрограмма' }} - {{ countNumber('ppr')}}</span>
                <span class="item-breadcrumb" v-if="reg_switch === false && codeCount.spf === 1">{{ 'Специфика' }} - {{ countNumber('spf')}}</span>
                <span class="item-breadcrumb" v-if="vzk !== null"> {{ vzk }}</span>
            </div>
        </div>
        <div class="table-container">
            <b-table
                :fields="tableFields"
                :items="arr"
                class="text-center"
                responsive="true"
                bordered
                head-variant="light"
                no-border-collapse
                sticky-header="true"
            >
                <template #thead-top="data">
                    <b-tr>
                        <b-th colspan="1"></b-th>
                        <b-th v-if="reg_switch === true" colspan="1" class="text-center">{{ 'Код бюджетной классификации' }}</b-th>
                        <b-th v-if="reg_switch === false && count_cut === 1" colspan="1" class="text-center">{{ 'Код бюджетной классификации' }}</b-th>
                        <b-th v-if="reg_switch === false && count_cut === 2" colspan="2" class="text-center">{{ 'Код бюджетной классификации' }}</b-th>
                        <b-th v-if="reg_switch === false && count_cut === 3" colspan="3" class="text-center">{{ 'Код бюджетной классификации' }}</b-th>
                        <b-th v-if="reg_switch === false && count_cut === 4" colspan="4" class="text-center">{{ 'Код бюджетной классификации' }}</b-th>
                        <b-th colspan="2"></b-th>
                        <b-th colspan="2" class="text-center">{{ 'Сводный план на отчетный период' }}</b-th>
                        <b-th colspan="5"></b-th>
                    </b-tr>
                </template>
                <template #top-row="data">
                    <td v-for="(field, c) in data.fields"
                        :key="c + field" class="td-numbering">
                        <div class="text-center" v-if="c !== 0">
                            {{ c }}
                        </div>
                    </td>
                </template>
                <template #top-row="data" v-if="totals !== null">
                    <td v-if="reg_switch === true" class="text-center" colspan="3">{{ totals.name_ru }}</td>
                    <td v-if="reg_switch === false && count_cut === 1" class="text-right" colspan="3">{{ totals.name_ru }}</td>
                    <td v-if="reg_switch === false && count_cut === 2" class="text-right" colspan="4">{{ totals.name_ru }}</td>
                    <td v-if="reg_switch === false && count_cut === 3" class="text-right" colspan="5">{{ totals.name_ru }}</td>
                    <td v-if="reg_switch === false && count_cut === 4" class="text-right" colspan="6">{{ totals.name_ru }}</td>
                    <td class="text-left">{{ $n(toNum(totals.row5)) }}</td>
                    <td class="text-left">{{ $n(toNum(totals.row6)) }}</td>
                    <td class="text-left">{{ $n(toNum(totals.row7)) }}</td>
                    <td class="text-left">{{ $n(toNum(totals.row8)) }}</td>
                    <td class="text-left">{{ totals.row6 > 0 ? $n(toNum((totals.row8 / totals.row6) * 100)) : 0 }}</td>
                    <td class="text-left">{{ $n(toNum(totals.row8 - totals.row6)) }}</td>
                    <td class="text-left">{{ $n(toNum(totals.row11)) }}</td>
                    <td class="text-left">{{ $n(toNum(totals.row11 - totals.row7)) }}</td>
                </template>
                <template #cell(action)="data">
                    <b-button v-if="data.item.type === buttonOpenChildDisplay('action')" @click="openChilds(data.item)">
                        <i class="icon icon-chevron-circle icon-rotate-180" v-if="data.item.open"></i>
                        <i class="icon icon-chevron-circle" v-if="!data.item.open"></i>
                    </b-button>
                </template>
                <template #cell(abp)="data">
                    <div v-if="data.item.type === 3" class="text-center">{{ data.value }}</div>
                    <b-button v-if="(data.item.type === buttonOpenChildDisplay('abp'))"
                              @click="openChilds(data.item)">
                        <i class="icon icon-chevron-circle icon-rotate-180" v-if="data.item.open"></i>
                        <i class="icon icon-chevron-circle" v-if="!data.item.open"></i>
                    </b-button>
                </template>
                <template #cell(prg)="data">
                    <div v-if="data.item.type === 4" class="text-center">{{ data.value }}</div>
                    <b-button v-if="(data.item.type === buttonOpenChildDisplay('prg'))"
                              @click="openChilds(data.item)">
                        <i class="icon icon-chevron-circle icon-rotate-180" v-if="data.item.open"></i>
                        <i class="icon icon-chevron-circle" v-if="!data.item.open"></i>
                    </b-button>
                </template>
                <template #cell(ppr)="data">
                    <div v-if="data.item.type === 5" class="text-left">{{ data.value }}</div>
                </template>
                <template #cell(spf)="data">
                    <div v-if="data.item.type === 6" class="text-left">{{ data.value }}</div>
                </template>
                <template #cell(region)="data">
                    <div class="text-center">{{ data.value }}</div>
                </template>
                <template #cell()="data">
                    <div class="text-left">{{ $n(toNum(data.value)) }}</div>
                </template>
                <template #cell(name_ru)="data">
                    <div class="text-left">
                        {{ data.item.name_ru }}
                    </div>
                </template>

            </b-table>
        </div>
        <div>
            <loading
                :active="loading"
                is-full-screen
                spinner="bar-fade-scale"
                color="#6495ED"
            />
        </div>
        <div class="actions-tab in-tab">
            <b-dropdown variant="link" right toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                    <div class="btn-download">
                        <div>
                            <span class="left">
                                <i class="icon icon-download"></i> Скачать
                            </span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <b-dropdown-item @click="downloadRep">{{ labelText }}</b-dropdown-item>
            </b-dropdown>
        </div>
    </div>


</template>
<script>
import {Ax} from '@/utils';
import moment from 'moment';
import VueElementLoading from "vue-element-loading";
function calculateRow9(arr) {
    arr.forEach(item => {
        item.row9 = item.row6 === 0 ? 0 : (item.row8 / item.row6 * 100).toFixed(1);
        if (item.child && item.child.length > 0) {
            calculateRow9(item.child);
        }
    });
}

export default {
    name: "application-form-7",
    components: {'loading': VueElementLoading},
    props: ['curReport'],
    data() {
        return {
            obl: null,
            listReg: [],
            curParams: {},
            dateFrom: null,
            firstDateFrom: `${new Date().getFullYear()}` + '-01' + '-01',
            firstDateTo: `${new Date().getFullYear()}-${new Date().getMonth()}-${new Date(new Date().getFullYear(), new Date().getMonth(), 0).getDate()}`,
            dateTo: null,
            isLoad: false,
            isSave: false,
            isOpen: false,
            repName: 'Приложение_7',
            originalTableFields: [
                { key: 'action', label: '', class: 'toggle-show' },
                { key: 'region', label: 'Регион' },
                { key: 'abp', label: 'АБП' },
                { key: 'prg', label: 'БП' },
                { key: 'ppr', label: 'БПП' },
                { key: 'spf', label: 'СП' },
                { key: 'name_ru', label: 'Наименование' },
                { key: 'row5', label: 'Скорректированный бюджет на отчетный финансовый год' },
                { key: 'row6', label: 'по платежам' },
                { key: 'row7', label: 'по обязательствам' },
                { key: 'row8', label: 'Оплаченные обязательства' },
                { key: 'row9', label: '% исполнения' },
                { key: 'row10', label: 'Сумма неисполнения' },
                { key: 'row11', label: 'Принятые обязательства' },
                { key: 'row12', label: 'Сумма непринятых обязательств' },
            ],
            tableFields: [
                {
                    key: 'action',
                    label: '',
                    thClass: null,
                    class: 'toggle-show'
                },
                {
                    key: 'abp',
                    label: 'АБП'
                },
                {
                    key: 'prg',
                    label: 'БП'
                },
                {
                    key: 'ppr',
                    label: 'БПП'
                },
                {
                    key: 'spf',
                    label: 'СП'
                },
                {
                    key: 'name_ru',
                    label: 'Наименование'
                },
                {
                    key: 'row5',
                    label: 'Скорректированный бюджет на отчетный финансовый год'
                },
                {
                    key: 'row6',
                    label: 'по платежам'
                },
                {
                    key: 'row7',
                    label: 'по обязательствам'
                },
                {
                    key: 'row8',
                    label: 'Оплаченные обязательства'
                },
                {
                    key: 'row9',
                    label: '% исполнения'
                },
                {
                    key: 'row10',
                    label: 'Сумма неисполнения'
                },
                {
                    key: 'row11',
                    label: 'Принятые обязательства'
                },
                {
                    key: 'row12',
                    label: 'Сумма непринятых обязательств'
                }
            ],
            listReports: [],
            arr: [],
            abp: null,
            prg: null,
            ppr: null,
            spf: null,
            reg: null,
            reg_name: null,
            abpListCount: 0,
            prgListCount: 0,
            pprListCount: 0,
            spfListCount: 0,
            count_cut: 4,
            codeCount: {abp: 0, prg: 0, ppr: 0, spf: 0},
            totals: null,
            loadingF: false,
            loading: false,
            arrForm: [],
            vzk: null,
            arrFormTemp: [],
            arrDataMap: new Map(),
            reg_switch: false
        };
    },
    beforeUpdate() {
        for (const row of this.arr) {
            if ([3].includes(row.type)) {
                row._rowVariant = 'primary';
            }
            if ([4, 5].includes(row.type)) {
                row._rowVariant = "info";
            }
        }
    },
    created() {
        this.$on('loadData', (reg, reg_name, period, date_to, month, year, abpL, prgL, pprL, spfL, uuid, obl, reg_switch, vzk) => {
            this.reportOpen7(reg, period, date_to, month, year, abpL, prgL, pprL, spfL, uuid, obl, reg_switch, vzk);
            this.reg = reg;
            this.vzk = vzk.text;
            this.reg_name = reg_name;
            this.abpListCount = abpL;
            this.prgListCount = prgL;
            this.pprListCount = pprL;
            this.spfListCount = spfL;
            this.reg_switch = reg_switch;
            if (reg_switch === false) {
                let localCount = 0;
                if (abpL !== '') {
                    localCount += 1;
                }
                if (prgL !== '') {
                    localCount += 1;
                }
                if (pprL !== '') {
                    localCount += 1;
                }
                if (spfL !== '') {
                    localCount += 1;
                }
                this.count_cut = localCount;
            }
        });
    },
    computed: {
        labelText() {
            return this.curReport.name_ru;
        },
        buttonVar() {
            return this.isSave ? "success" : "secondary";
        },
        ReportName(){
            if (this.reg_switch === false){
                const components = { abp: 'АБП', prg: 'Программа', ppr: 'Подпрограмма', spf: 'Специфика' };
                const includedComponents = [];

                if (this.codeCount.abp) includedComponents.push(components.abp);
                if (this.codeCount.prg) includedComponents.push(components.prg);
                if (this.codeCount.ppr) includedComponents.push(components.ppr);
                if (this.codeCount.spf) includedComponents.push(components.spf);

                return 'Приложение 7(' + includedComponents.join('+') + ')';
            } else {
                return 'Приложение 7 в разрезе регионов';
            }
        },
    },

    methods: {
        countNumber(code) {
            if (code === 'abp'){
                if (this.abpListCount === '000'){
                    return 'Все';
                }
                else {
                    return `Выбрано ${this.abpListCount.split(',').length}`;
                }
            }
            if (code === 'prg'){
                if (this.prgListCount === '000'){
                    return 'Все';
                }
                else {
                    return `Выбрано ${this.prgListCount.split(',').length}`;
                }
            }
            if (code === 'ppr'){
                if (this.pprListCount === '000'){
                    return 'Все';
                }
                else {
                    return `Выбрано ${this.pprListCount.split(',').length}`;
                }
            }
            if (code === 'spf'){
                if (this.spfListCount === '000'){
                    return 'Все';
                }
                else {
                    return `Выбрано ${this.spfListCount.split(',').length}`;
                }
            }
        },
        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                appendToast: true
            });
        },
        async reportOpen7(reg, period, date_to, month, year, abpL, prgL, pprL, spfL, uuid, obl, reg_switch, vzk) {
            this.loading = true;
            this.firstDateTo = new Date(date_to);
            this.curParams = {
                region: reg,
                period: period,
                date_to: moment(this.firstDateTo).format('YYYY-MM-DD'),
                month: month,
                year: year,
                abpL: abpL,
                prgL: prgL,
                pprL: pprL,
                spfL: spfL,
                user_id: uuid,
                obl: obl,
                reg_switch: reg_switch,
                vzk: vzk.code,
            };
            this.tableFields = [...this.originalTableFields];
            if (reg_switch === true) {
                this.tableFields = this.tableFields.filter(field => field.key !== 'abp' && field.key !== 'prg' &&
                    field.key !== 'ppr' && field.key !== 'spf');
            }
            else if (reg_switch === false) {
                this.codeCount.abp = abpL !== '' ? 1 : 0;
                this.codeCount.prg = prgL !== '' ? 1 : 0;
                this.codeCount.ppr = pprL !== '' ? 1 : 0;
                this.codeCount.spf = spfL !== '' ? 1 : 0;
                this.tableFields = this.tableFields.filter(field => field.key !== 'region');
                if (this.codeCount.abp === 0){
                    this.tableFields = this.tableFields.filter(field => field.key !== 'abp');
                }
                if (this.codeCount.prg === 0){
                    this.tableFields = this.tableFields.filter(field => field.key !== 'prg');
                }
                if (this.codeCount.ppr === 0){
                    this.tableFields = this.tableFields.filter(field => field.key !== 'ppr');
                }
                if (this.codeCount.spf === 0){
                    this.tableFields = this.tableFields.filter(field => field.key !== 'spf');
                }
            }
            const response = await fetch(`/api-py/get-fulldata-7/` + JSON.stringify(this.curParams));
            const data = await response.json();
            this.arr = data.arr;
            this.totals = data.totals;
            this.dateTo  = data.period;
            calculateRow9(this.arr);
            this.toOpen();
            await this.prepareForm();
            this.loading = false;
            if (this.arr.length === 0){
                this.makeToast('info', 'Внимание', 'Данных по таким параметрам нет.');
            }
        },
        toOpen() {
            this.isOpen = !this.isOpen;
            this.$emit('repOpen', this.isOpen);
        },
        buttonOpenChildDisplay(code) {
            const levels = Object.keys(this.codeCount).filter(field => this.codeCount[field] === 1); // find active
            const typeToField = {3: 'abp', 4: 'prg', 5: 'ppr', 6: 'spf'};
            const levelsTypes = Object.entries(typeToField)
                .filter(([type, field]) => levels.includes(field))
                .map(([type]) => parseInt(type, 10));

            if (code === 'action' && levelsTypes.length !== 1) {
                if (this.reg_switch === false) {
                    return levelsTypes[0];
                }
            } else if (code === 'abp') {
                const index = levelsTypes.indexOf(3);
                if (index !== -1 && index + 1 < levelsTypes.length - 1) {
                    return levelsTypes[index + 1];
                }
            } else if (code === 'prg') {
                const index = levelsTypes.indexOf(4);
                if (index !== -1 && index + 1 < levelsTypes.length - 1) {
                    return levelsTypes[index + 1];
                }
            }
            return null;
        },
        downloadRep() {
            try {
                this.makeToast('info', 'Внимание!', 'Скоро начнется скачивание. Пожалуйста ожидайте.');
                this.isLoad = true;
                this.curParams.lang = this.$i18n.locale;
                Ax(
                    {
                        url: '/api-py/fulfill_report7/' + JSON.stringify(this.curParams),
                        method: 'POST',
                        responseType: 'blob'
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', this.labelText + '.xlsx');
                        document.body.appendChild(link);
                        link.click();
                    },
                    (error) => {
                        this.makeToast('danger', 'Ошибка запроса downloadRep()', error.toString());
                    }
                );
            } catch (error) {
                console.log(error)
                this.makeToast('danger', 'Предупреждение', 'Необходимо заполнить все обязательные фильтры!');
            } finally {
                this.isLoad = false
            }
        },
        keyPress: function (event, pattern) {
            const regex = new RegExp(pattern);
            const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
        }, // вводит по заданному паттерну
        keyup13: function (event) {
            event.preventDefault();
            // Isolate the node that we're after
            const currentNode = event.target;
            // find all tab-able elements
            const allElements = document.querySelectorAll('input'); // area, object, select, [contenteditable]
            // Find the current tab index.
            const currentIndex = [...allElements].findIndex(el => currentNode.isEqualNode(el));
            // select/focus the following element
            const targetIndex = (currentIndex + 1) % allElements.length;
            if (targetIndex < allElements.length) {
                allElements[targetIndex].select();
            }
        }, // enter работает как tab
        inputFixed(item, field, value, digit) {
            this.$set(item, field, parseFloat(parseFloat(value).toFixed(digit)));
        }, // форматирует введенное значение до digit цифр после запятой
        createTable(elem, parentId) { // создание таблицы на основе дерева
            const that = this;

            const item = Object.assign({}, elem);

            that.$set(item, 'parent_id', parentId);
            that.$set(item, 'visible', true);

            const par = that.arrDataMap.get(item.parent_id);
            if (par) {
                if (par.hasOwnProperty('newchild')) {
                    that.$set(par.newchild, par.newchild.length, item);
                } else {
                    that.$set(par, 'newchild', []);
                    that.$set(par.newchild, par.newchild.length, item);
                }
            }
            Object.defineProperty(item, 'parent', {
                get: function () {
                    const par = that.arrDataMap.get(item.parent_id);
                    if (par) {
                        return par;
                    }
                    return null;
                }
            });

            that.$set(item, 'index', that.arrFormTemp.length);
            that.$set(that.arrFormTemp, that.arrFormTemp.length, item);
            that.arrDataMap.set(item.id, item);
            if (item.hasOwnProperty('child') && (item.child.length > 0)) {
                that.$set(item, 'open', true);
                that.$set(item, 'hasChild', true);
            }

            if (item.hasChild) {
                for (const ch of item.child) {
                    that.createTable(ch, item.id);
                }
                delete item.child;
            }
        }, // древовидную выборку преобразовывает в таблицу (для отображения)
        async prepareForm() {
            this.arrForm = [];
            this.arrFormTemp = [];
            this.arrDataMap = new Map();
            for (const item of this.arr) {
                await this.createTable(item, 0);
            }
            for (const item of this.arrFormTemp) {
                if (item.type === 2) {
                    item.open = false;
                    this.arrForm.push(item)
                }
            }
        }, // подготовка отображения данных
        compare_spf(a, b) {
            if (a.spf < b.spf) {
                return -1;
            }
            if (a.spf > b.spf) {
                return 1;
            }
            return 0;
        },
        compare_ppr(a, b) {
            if (a.ppr < b.ppr) {
                return -1;
            }
            if (a.ppr > b.ppr) {
                return 1;
            }
            return 0;
        },
        compare_prg(a, b) {
            if (a.prg < b.prg) {
                return -1;
            }
            if (a.prg > b.prg) {
                return 1;
            }
            if (a.ppr === undefined) {
                return -1;
            }
            if (b.ppr === undefined) {
                return 1;
            }
            return 0;
        },
        compare_abp(a, b) {
            if (a.abp < b.abp) {
                return -1;
            }
            if (a.abp > b.abp) {
                return 1;
            }
            if (a.prg === undefined) {
                return -1;
            }
            if (b.prg === undefined) {
                return 1;
            }
            return 0;
        },
        compare_null(a, b) {
            if ((a.abp === undefined) || (b.abp !== undefined)) {
                return -1;
            }
            return 1;
        },
        openChilds(parent, bool) {
            parent.open = (bool === undefined ? !parent.open : bool);
            if (parent.child) {
                let dat = parent.child;
                dat = dat.sort(this.compare_spf);
                dat = dat.sort(this.compare_ppr);
                dat = dat.sort(this.compare_prg);
                dat = dat.sort(this.compare_abp);
                dat = dat.sort(this.compare_null);
                for (const row of dat) {
                    if ((parent.id === row.parent_id)) {
                        // this.changeDevelop(row);
                        const ind = this.arr.indexOf(parent);
                        if (this.arr.indexOf(row) < 0) {
                            this.arr.splice(ind + 1, 0, row);
                        }
                        if ([3, 4, 5, 6].includes(row.type)) {
                            this.openChilds(row, parent.open);
                            row.visible = parent.open;
                            row.open = parent.open;
                        }
                        // if ([6].includes(row.type)) {
                        //     row.visible = false;
                        // }
                        if ([5].includes(row.type)) {
                            row.visible = parent.open;
                            row.open = false;
                            this.openChilds(row, row.open);
                        }
                        if ([5].includes(parent.type)) {
                            this.openChilds(row, parent.open);
                            row.visible = parent.open;
                            row.open = parent.open;
                        }
                        if ((this.arr.indexOf(row) > 0) && (!row.visible)) {
                            this.arr.splice(this.arr.indexOf(row), 1);
                        }
                        this.deleteNulls();
                    }
                }
            }
        },
        toNum(value, fix = 1) {
            if (typeof (value) === 'string') {
                return parseFloat(parseFloat(value).toFixed(fix));
            }
            if (typeof (value) === 'number') {
                return parseFloat(value.toFixed(fix));
            }
            if (typeof (value) === 'boolean') {
                return (value === true ? 1 : 0);
            }
            if (typeof (value) === 'undefined') {
                return 0;
            }
            if (isNaN(value)) {
                return 0;
            }
            if (isFinite(value)) {
                return 0;
            }
            if (value === null) {
                return 0;
            }
        },


        // открывает/закрывает ветку до конечного элемента
        async deleteNulls() {
            for (const row of this.arr) {
                if (parseFloat(row.row5)
                    + parseFloat(row.row6)
                    + parseFloat(row.row7)
                    + parseFloat(row.row8)
                    + parseFloat(row.row11) === 0) {
                    row.visible = false;
                }
            }
        }
    }
}
</script>

<style scoped>
.td-numbering {
    padding: 3px 10px !important;
    text-align: center;
    font-size: 0.7rem !important;
    font-weight: 400 !important;
    color: #6087A0 !important;
    background-color: #F7F9FC;
}
</style>
